/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentNotesFormClose: "shipment-notes-form-close",
  shipmentNotesFormCancel: "shipment-notes-form-cancel",
  shipmentNotesFormValidate: "shipment-notes-form-validate",
} as const;
